import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { PrimaryBold } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { LinkExternal } from "@ui/components/linkExternal";
import { moreInfos } from "@ui/pages/more/moreInfos";

type MoreProps = React.HTMLAttributes<HTMLDivElement>;

export const More: React.FC<MoreProps> = ({ ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{moreInfos.map(({ page, pathname, icon }) => (
				<Cell key={page}>
					{page !== "support" ? (
						<LinkExternal to={pathname}>
							<CellContent>
								<IconWrapper>
									<img src={icon} />
								</IconWrapper>
								<PageName>{I18n.t(`more.page.${page}`)}</PageName>
							</CellContent>
						</LinkExternal>
					) : (
						<a href={`mailto:${pathname}`}>
							<CellContent>
								<IconWrapper>
									<img src={icon} />
								</IconWrapper>
								<PageName>{I18n.t(`more.page.${page}`)}</PageName>
							</CellContent>
						</a>
					)}
				</Cell>
			))}
		</Container>
	);
};

const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, 250px);
	grid-auto-rows: 245px;
	grid-row-gap: 48px;
	grid-column-gap: 48px;

	@media (max-width: 900px) {
		justify-content: center;
	}
`;

const Cell = styled.div`
	display: flex;
	a {
		flex: 1;
		display: flex;
	}
`;

const CellContent = styled(RoundedBlock)`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	padding: 56px 60px 0;
`;

const IconWrapper = styled.div`
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ theme }) => theme.colors.primary};
	border-radius: 40px;

	img {
		width: 33px;
		height: 33px;
	}
`;

const PageName = styled(PrimaryBold)`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
`;
